import marked from "marked";
import sanitizeHtml from "sanitize-html";


function markdownToHTML(value) {
    let html = marked(value);
    html = html.replaceAll(/<a +href="([^"]+)" *>([^<]+)<.a>/g, '<a target="_blank" href="$1">$2</a>')
    return sanitizeHtml(html, {
        allowedTags: [ 'p', 'code', 'b', 'i', 'em', 'strong', 'a', 'br', 'li', 'ul'],
        allowedAttributes: {
            'a': [ 'href', 'target' ]
        },
    });
}

export { markdownToHTML }
